import angular from 'angular';

angular
  .module('cloudX')
  .controller('EditTaskScheduleRemarkDialogCtrl', [
    '$element',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'taskScheduleId',
    'value',
    editTaskScheduleRemarkDialogCtrl,
  ]);

function editTaskScheduleRemarkDialogCtrl(
  $element,
  $http,
  appUrls,
  flySvc,
  close,
  taskScheduleId,
  value,
) {
  const vm = this;
  vm.saving = false;
  vm.value = value || '';
  vm.save = function() {
    if (vm.saving) return;
    if ((value || '') === (vm.value || '')) {
      //Value not changed -> cancel
      $element.modal('hide');
      close(null, 500);
      return;
    }
    vm.saving = true;
    $http
      .put(`${appUrls.tasks}/api/TaskSchedules/Remark`, { taskScheduleId, remark: vm.value })
      .then(() => {
        $element.modal('hide');
        close({ value: vm.value }, 500);
      }, flySvc.error)
      .finally(() => {
        vm.saving = false;
      });
  };
  vm.close = function() {
    $element.modal('hide');
    close(null, 500);
  };

  vm.loaded = true;
}
